import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";

export async function igualarParcelasPrazo() {
    await microuniversoApi.Orcamento.igualarParcelasPrazo(
        store.getState().orcamento.IdentificadorOrcamento
    )

}